// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/cluster_class.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file chalk/server/v1/cluster_class.proto.
 */
export const file_chalk_server_v1_cluster_class: GenFile = /*@__PURE__*/
  fileDesc("CiNjaGFsay9zZXJ2ZXIvdjEvY2x1c3Rlcl9jbGFzcy5wcm90bxIPY2hhbGsuc2VydmVyLnYxKmUKDENsdXN0ZXJDbGFzcxIdChlDTFVTVEVSX0NMQVNTX1VOU1BFQ0lGSUVEEAASGAoUQ0xVU1RFUl9DTEFTU19IT1NURUQQARIcChhDTFVTVEVSX0NMQVNTX1NFUlZFUkxFU1MQAkIUWhJzZXJ2ZXIvdjE7c2VydmVydjFiBnByb3RvMw");

/**
 * Classification of how a cluster is provisioned/billed. UNSPECIFIED and HOSTED are both treated
 * as hosted in software; only SERVERLESS denotes a serverless cluster.
 *
 * Lives in its own leaf file (no imports) so that environment.proto and cloud_components.proto can
 * both reference it without an import cycle.
 *
 * @generated from enum chalk.server.v1.ClusterClass
 */
export enum ClusterClass {
  /**
   * @generated from enum value: CLUSTER_CLASS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CLUSTER_CLASS_HOSTED = 1;
   */
  HOSTED = 1,

  /**
   * @generated from enum value: CLUSTER_CLASS_SERVERLESS = 2;
   */
  SERVERLESS = 2,
}

/**
 * Describes the enum chalk.server.v1.ClusterClass.
 */
export const ClusterClassSchema: GenEnum<ClusterClass> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_cluster_class, 0);

